/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState, useContext, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  TextInput, Select, Checkbox, Form, Button, PhoneInput,
} from 'components/common';
import { getObjectByLanguage } from 'language/helpers';
import { UserContext } from 'contexts/userContext';
import { saleRequest } from 'models/machinery';
import { StatusContext } from 'contexts/statusContext';
import {
  emailValidator,
  minLengthValidator,
  nameValidator,
  nameWithNumberValidator,
} from 'utils/formValidators';

const PersonalInformation = ({
  t, machineData, updateMachineData, sources, setCurrentStep, setMachineData,
}) => {
  const { setErrorState } = useContext(StatusContext);
  const { userData } = useContext(UserContext);
  const user = userData;

  const [onResponse, setOnResponse] = useState(false);
  let formRef = useRef();
  const [isUserFromTr, setIsUserFromTr] = useState(false);

  useEffect(() => {
    if (user) {
      setIsUserFromTr(sources.countries
        .find((country) => country.id === user.country)
        ?.dialCode === '90');
      setMachineData({
        ...machineData,
        customerName: user.name,
        customerSurname: user.surname,
        customerCountry: user.country,
        customerIdentificationNumber: user.identification,
        customerPassportNumber: user.passportNumber,
        customerMail: user.email,
        customerPhone: user.phone,

      });
      formRef.setFieldsValue({
        customerName: user.name,
        customerSurname: user.surname,
        customerCountry: user.country,
        customerIdentificationNumber: user.identification,
        customerPassportNumber: user.passportNumber,
        customerMail: user.email,
        customerPhone: user.phone,
      });
    }
  }, []);

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        const { _id: requestId } = await saleRequest(machineData);
        updateMachineData({ name: 'requestId', value: requestId });
        setCurrentStep('CodeEnterence');
      } catch (error) {
        console.log('registerErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-6 offset-lg-1 mt-5 mt-md-0">
      <Form
        layout="vertical"
        onFinish={onFormSubmit}
        formRef={(ref) => formRef = ref}
      >
        <div className="fs-22 mb-2">{t('stepNumber', { step: 3 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('enterYourPersonalInformation')}</div>
        <div className="mb-4">
          <p>Kişisel bilgileriniz KVKK kapsamında korunacak, 3. Şahıslarla kesinlikle paylaşılmayacaktır.</p>
        </div>

        <div className="row mb-3">
          <div className="col">
            <TextInput
              name="customerName"
              placeholder={t('name')}
              value={machineData.customerName}
              onChange={updateMachineData}
              defaultValue={user ? user.name : ''}
              required
              validator={nameValidator}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <TextInput
              name="customerSurname"
              placeholder={t('surname')}
              value={machineData.customerSurname}
              onChange={updateMachineData}
              defaultValue={user ? user.surname : ''}
              required
              validator={nameValidator}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-15 col-sm mb-3 mb-sm-0">
            <Select
              name="customerCountry"
              placeholder={t('country')}
              onChange={(value) => {
                updateMachineData({ name: 'customerCountry', value: value.value });
                setIsUserFromTr(sources.countries
                  .find((country) => country.id === value.value)
                  ?.dialCode === '90');
              }}
              value={machineData.customerCountry}
              options={_.map(sources.countries, (country) => {
                return { value: country.id, text: getObjectByLanguage(country.name) };
              })}
              defaultValue={user ? user.country : ''}
              showSearch
              filterOption={(input, opt) => opt.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0}
              required
            />
          </div>
          <div className="col-15 col-sm">
            {isUserFromTr ? (
              <TextInput
                type="tel"
                id="only-number"
                name="customerIdentificationNumber"
                maxLength={11}
                placeholder={t('identification')}
                value={machineData.customerIdentificationNumber}
                onChange={({ value }) => {
                  const fixedInput = value.replace(/[^0-9]/g, '');
                  formRef.setFieldsValue({
                    customerIdentificationNumber: fixedInput,
                  });
                  updateMachineData({ name: 'customerIdentificationNumber', value: fixedInput });
                }}
                validator={(rule, value) => minLengthValidator(value, 11)}
                defaultValue={user ? user.identification : ''}
                required
              />
            ) : (
              <TextInput
                type="text"
                name="customerPassportNumber"
                placeholder={t('passportNumber')}
                maxLength={9}
                value={machineData.customerPassportNumber}
                onChange={({ value }) => {
                  const fixedInput = value.replace(/[^0-9]/g, '');
                  formRef.setFieldsValue({
                    customerPassportNumber: fixedInput,
                  });
                  updateMachineData({ name: 'customerPassportNumber', value: fixedInput });
                }}
                validator={(rule, value) => minLengthValidator(value, 7)}
                defaultValue={user ? user.passportNumber : ''}
                required
              />
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <TextInput
              type="email"
              name="customerMail"
              placeholder={t('email')}
              value={machineData.customerMail}
              onChange={updateMachineData}
              defaultValue={user ? user.email : ''}
              validator={!_.isEmpty(machineData.customerMail) && emailValidator}
              required
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <PhoneInput
              name="customerPhone"
              label={t('phoneNumber')}
              value={machineData.customerPhone}
              onChange={updateMachineData}
              required
              mobileNumber
            />
          </div>
        </div>

        <div className="row mt-5 mb-5">
          <div className="col-15">
            <div className="fs-18 fw-700 mb-4">Şirket Bilgileri</div>
          </div>
          <div className="col-15">
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  name="customerCompanyName"
                  placeholder="Şirket İsminiz (Resmi Kayıtlarda Geçtiği Şekliyle)"
                  value={machineData.customerCompanyName}
                  onChange={updateMachineData}
                  required
                  validator={nameWithNumberValidator}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  name="customerTitle"
                  placeholder="Şirketteki Göreviniz"
                  value={machineData.customerTitle}
                  onChange={updateMachineData}
                  required
                  validator={nameWithNumberValidator}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Select
                  name="customerTaxOffice"
                  placeholder={t('taxOffice')}
                  onChange={updateMachineData}
                  value={machineData.customerTaxOffice}
                  options={_.map(sources.taxOffices, (taxOffice) => {
                    return { value: taxOffice.id, text: getObjectByLanguage(taxOffice.name) };
                  })}
                  showSearch
                  filterOption={(input, opt) => opt.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0}
                  required
                />
              </div>
              <div className="col">
                <TextInput
                  type="text"
                  id="only-number"
                  name="customerTaxNumber"
                  placeholder={t('taxNumber')}
                  maxLength={11}
                  value={machineData.customerTaxNumber}
                  onChange={({ value }) => {
                    const fixedInput = value.toLocaleUpperCase().replace(/[^0-9A-Z]/g, '');
                    formRef.setFieldsValue({
                      customerTaxNumber: fixedInput,
                    });
                    updateMachineData({ name: 'customerTaxNumber', value: fixedInput });
                  }}
                  validator={(rule, value) => minLengthValidator(value, 10)}
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5 mb-5">
          <div className="col-15">
            <div className="fs-18 fw-700 mb-4">{t('whereDidYouHearAboutUs')}</div>
          </div>
          <div className="col-15">
            <div className="row">
              <div className="col">
                <Select
                  name="customerLearnedFrom"
                  placeholder={t('channel')}
                  onChange={updateMachineData}
                  value={machineData.customerLearnedFrom}
                  options={_.map(sources.learnedFroms, (learnedFrom) => {
                    return { value: learnedFrom.id, text: getObjectByLanguage(learnedFrom.name) };
                  })}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-15">
            <div className="fs-18 fw-700 mb-4">Makine parkı büyüklüğünüz</div>
          </div>
          <div className="col-15">
            <div className="row">
              <div className="col">
                <Select
                  name="customerMachineParkSize"
                  placeholder={t('numberOfMachines')}
                  onChange={updateMachineData}
                  value={machineData.customerMachineParkSize}
                  options={[
                    { value: '1', text: '1' },
                    { value: '2', text: '2' },
                    { value: '3', text: '3' },
                    { value: '4', text: '4' },
                    { value: '5', text: '5' },
                    { value: '5-25', text: '5-25' },
                    { value: '25-50', text: '25-50' },
                    { value: '50-100', text: '50-100' },
                    { value: '100-500', text: '100-500' },
                    { value: '500+', text: '500+' },
                    { value: '0', text: 'Makina Parkım Yok' },
                  ]}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-2 mt-5">
          <div className="col">
            <Checkbox
              name="agreementKvkk"
              value={machineData.agreementKvkk}
              onChange={updateMachineData}
              text={(
                <>
                  <a className="fw-700" href="#agreementModal" data-toggle="modal">Sözleşmeyi</a>
                  {' '}
                  okudum, kabul ediyorum.
                </>
              )}
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <Checkbox
              containerClassName="mb-4"
              name="agreementMessaging"
              value={machineData.agreementMessaging}
              onChange={updateMachineData}
              text={(
                <>
                  <a className="fw-700">Kişisel Verilerin İşlenmesi ile ilgili Aydınlatma Metni</a>
                  ’ni okudum.
                </>
              )}
              required
            />
          </div>
        </div>
        <div className="separator separator--horizontal separator--opacity-1 mb-4" />

        <div className="fs-13 fw-700 mb-2">Kişisel Verilerin İşlenmesi ve Elektronik Ticari İleti</div>
        <p className="fs-13">
          İş bu form ile paylaştığınız kişisel verileriniz sizlere sunmuş olduğumuz Aydınlatma Metni’nde gösterildiği şekilde
          işlenecektir. Ek olarak, kişisel verilerinizin size özel hizmetler oluşturulması ve tanıtılması için pazarlama
          faaliyetlerinde kullanılmasını, tarafımıza ilettiğiniz iletişim bilgilerinize Şirketimizce reklam, promosyon, vb. ticari
          elektronik ileti gönderilmesini ve bilgilerinizin gönderim için hizmet alınan üçüncü kişilerle paylaşılmasını kabul
          ediyor musunuz?
        </p>

        <div className="row">
          <div className="col">
            <Checkbox
              value={machineData.agreementDistanceSelling}
              onChange={updateMachineData}
              name="agreementDistanceSelling"
              text={<a className="fw-700 mr-1">Kabul Ediyorum</a>}
              required
            />
          </div>

        </div>
        <Button
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('next')}
          loading={onResponse}
        />
      </Form>
    </div>
  );
};

PersonalInformation.propTypes = {
  t: PropTypes.func,
  machineData: PropTypes.object,
  updateMachineData: PropTypes.func,
  sources: PropTypes.object,
  setCurrentStep: PropTypes.func,
  setMachineData: PropTypes.func,
};

export default PersonalInformation;
